import { useMemo } from 'react';
import { useLocaleInfo } from 'typescript/context/locale_info';
import { useGetOrderSummary } from 'typescript/hooks/use_order_actions_client';
import { isPOBoxAddress, isPOBoxBlocked } from 'typescript/utilities/po_box';

const usePoBox = ({ orderNumber }) => {
  const { countryCode } = useLocaleInfo();
  const { orderSummaryData } = useGetOrderSummary({ orderNumber });

  // block continuing if the address is a PO box
  // and either the cart contains blocked items or PO box is disabled in the country
  const isPoBoxBlocked = useMemo(
    () =>
      isPOBoxAddress({
        countryCode,
        address: orderSummaryData?.shipping_address,
      }) &&
      isPOBoxBlocked({
        countryCode,
        lineItems: orderSummaryData?.cart_summary,
      }),
    [countryCode, orderSummaryData],
  );

  const showPoBoxWarning = useMemo(
    () =>
      isPOBoxAddress({
        countryCode,
        address: orderSummaryData?.shipping_address,
      }) && !isPoBoxBlocked,
    [countryCode, orderSummaryData, isPoBoxBlocked],
  );

  return { isPoBoxBlocked, showPoBoxWarning };
};

export default usePoBox;
